import { siteConfig } from '@/mocks/site';

export default function AboutPreview() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="bg-background-100 rounded-lg p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-shrink-0">
            <span className="inline-block font-calligraphy text-7xl md:text-8xl text-primary-500 leading-none">
              淫
            </span>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              关于{siteConfig.name}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              我们是一个专注于汉字文化深度研究的学术型知识平台。以「淫」字为切入点，通过对一个汉字的全方位考察——字形演变、语义分析、古籍用例、文化意蕴——展现中华文字体系的博大精深。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}